import React, { forwardRef, useEffect, useRef, useState } from "react";
import { pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import FixedNavBar from "@/components/fixedNavBar";
import { SearchBar, Image } from "antd-mobile";
import TableTbody from "@/components/tableTbody";
import { ITableColsRecordsGift } from "@/type";
import CalendarTime from "@/components/calendarTime";
import { useFinanceOrderRecords } from "@/hooks/useOrderRecords";
import useCustomTranslation from "@/hooks/useTranslation";

const CalendarTimeChildComponent = forwardRef(CalendarTime);
const RecordsGift: React.FC = () => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	const childRef = useRef<any>(null);
	const [firstPage, setFirstPage] = useState(true);
	const [value, setValue] = useState("");
	const params: any = {
		srcList: ["DEPOSIT_PARENT"],
		nickname: value,
	};
	const { data, hasMore, handleRefresh, handleFetchMore } =
		useFinanceOrderRecords(params, childRef);

	useEffect(() => {
		if (!firstPage) {
			setFirstPage(false);
			handleRefresh();
		}
	}, [value]);

	return (
		<div className="router-main">
			<FixedNavBar title={t("GiftRecord")} />
			<div className={classes.timeSearchWrap}>
				<div className="search">
					<SearchBar
						value={value}
						onChange={(val: string) => {
							setValue(val);
						}}
						onSearch={handleRefresh}
						placeholder="Search"
						style={{
							fontSize: pxToRem(12),
							fontWeight: "400",
							color: "#FFFFFF",
							"--border-radius": pxToRem(40),
							"--height": pxToRem(36),
							"--background": "#1E212B",
							"--placeholder-color": "#868FA8",
						}}
						icon={
							<Image
								src={require("@/assets/images/icons/search.png")}
								width={22}
								height={22}
							/>
						}
					/>
				</div>
				<CalendarTimeChildComponent
					ref={childRef}
					onSubmit={handleRefresh}
				/>
			</div>
			<div style={{ flex: 1, overflow: "hidden" }}>
				<TableTbody
					ITableCols={ITableColsRecordsGift}
					ITableData={data}
					handleRefresh={handleRefresh}
					handleFetchMore={handleFetchMore}
					hasMore={hasMore}
				/>
			</div>
		</div>
	);
};

export default RecordsGift;

const useStyles = createUseStyles({
	timeSearchWrap: {
		padding: {
			top: pxToRem(15),
			left: pxToRem(20),
			right: pxToRem(20),
		},
		"& .search": {
			border: "1px solid #4C66C7",
			borderRadius: pxToRem(40),
			"--adm-color-background": "#1E212B",
			"& .adm-input-element": {
				"--color": "#FFFFFF",
			},
		},
	},
});
